// import React from 'react';
import { render } from '@testing-library/react';
import React, { useState, useEffect, PureComponent, useRef, useMemo, useCallback, Fragment } from 'react';
// import Accordion from 'react-bootstrap/Accordion'

// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { NavLink } from 'react-router-dom';
import $ from 'jquery';   
import {
    BarChart,
    Bar,
    Cell,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ReferenceLine,
    ResponsiveContainer,
  } from 'recharts';
import "./EpicfinanceTrends.css";
import { isEqual } from "lodash";
import * as ReactBootstrap from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

import config from '../config';
import Sidebar from '../SideMenu';

// import { Accordion } from "react-bootstrap";
// var Accordion = require('react-bootstrap').Accordion;
// var Panel = require('react-bootstrap').Panel;
// var responseData;
const colors = ['#1A1549','#9DB1DB','#D0DEF5','#99103B','#B85876','#D296A9','#dcdcdc','#666666','#404040','#262626']
let bot3contriDummy = []

const data = [

  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    // amt: 2400,
  },
  {
    name: 'Page B',
    uv: -3000,
    pv: 1398,
    // amt: 2210,
  },
  {
    name: 'Page C',
    uv: -2000,
    pv: -9800,
    // amt: 2290,
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 3908,
    // amt: 2000,
  },
  {
    name: 'Page E',
    uv: -1890,
    pv: 4800,
    // amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: -3800,
    // amt: 2500,
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 4300,
    // amt: 2100,
  },

];
$(".accordion__item__header").on('click',function () {
  $(this).toggleClass("active");
  $(this).next("div").slideToggle(200);
});

// $(".InvestorInfo").on('click',function () {

//   // alert("HI");
// });
const VARdata = [
    {
      name: 'Page A',
      uv: 0.34,
    //   pv: 2400,
    //   amt: 2400,
    },
    {
      name: 'Page B',
      uv: 0.11,
    //   pv: 1398,
    //   amt: 2210,
    },
    {
      name: 'Page C',
      uv: -0.04,
    //   pv: -9800,
    //   amt: 2290,
    },
    {
      name: 'Page D',
      uv: 1.5,
    //   pv: 3908,
    //   amt: 2000, 
    },

  ];
  const SECdata = [
    {
      name: 'Page A',
      uv: -1,
    //   pv: 2400,
    //   amt: 2400,
    },
    {
      name: 'Page B',
      uv: -0.52,
    //   pv: 1398,
    //   amt: 2210,
    },
    {
      name: 'Page C',
      uv: -0.60,
    //   pv: -9800,
    //   amt: 2290,
    },
    {
      name: 'Page D',
      uv: 1.29,
    //   pv: 3908,
    //   amt: 2000, 
    },

  ];
 

const EpicfinanceTrends = () => {




const [products, setProducts] = useState([]);
const [productsVAR, setProductsVAR] = useState([]);
const [productsSectorPer, setProductsSectorPer] = useState([]);
const [productscommulativePerformance, setproductscommulativePerformance] = useState([]);

const [HeadingState, setHeadingState] = useState([]);
const [ObjectiveState, setObjectiveState] = useState([]);
const [TeamState, setTeamState] = useState([]);

const [StateSession, setStateSession] = useState([]);


const [FundNameState, setFundNameState] = useState([]);
const [LiteratureDataState, setLiteratureDataState] = useState([]);
const [LiteratureSummaryDataState, setLiteratureSummaryDataState] = useState([]);
const [KeyInveInfoState, setKeyInveInfoState] = useState([]);
const [PressCoverageState, setPressCoverageState] = useState([]);
const [ApplicationsState, setApplicationsState] = useState([]);
const [ReportsState, setReportsState] = useState([]);
const [offerDocumentState, setofferDocumentState] = useState([]);
const [LiteratureDate, setLiteratureDate] = useState([]);
const [FileNameState, setFileNameState] = useState([]);

// const [productscommulativePerformanceA, setproductscommulativePerformanceA] = useState([]);
const [SessionResponse, setSessionResponse] = useState([]);

const [products12monthsPerformance, setproducts12monthsPerformance] = useState([]);
const [productstop3contr, setproductstop3contr] = useState([]);
const [productsbot3contr, setproductsbot3contr] = useState([]);
const [productsCommentary, setproductsCommentary] = useState([]);
const [productsFundinfo, setproductsFundinfo] = useState([]);

const [CMSFundinfo, setCMSFundinfo] = useState([]);
const [CMSshareinfo, setCMSshareinfo] = useState([]);


const [productsShareClass, setproductsShareClass] = useState([]);
const [productsMonthlyPerf, setproductsMonthlyPerf] = useState([]);
const [productsMonthlyPerfUSD, setproductsMonthlyPerfUSD] = useState([]);
const [productsMonthlyPerfUSDB, setproductsMonthlyPerfUSDB] = useState([]);
const [productsMonthlyPerfAEUR, setproductsMonthlyPerfAEUR] = useState([]);
const [productsMonthlyPerfBEUR, setproductsMonthlyPerfBEUR] = useState([]);
const [productsMonthlyPerfAGBP, setproductsMonthlyPerfAGBP] = useState([]);

const [portfolioStatus, setportfolioStatus] = useState(false);
const [performanceStatus1, setperformanceStatus1] = useState(false);

const [graphData, setgraphData] = useState([]);
const [graphDataVAR, setgraphDataVAR] = useState([]);
const[graphDataSectorPer,setgraphDataSectorPer]= useState([]);
const[cummulatovePerfData,setcummulatovePerfData]= useState([]);
const[twelvemonPerfDiscreteAPI,settwelvemonPerfDiscreteAPI]= useState([]);
const[top3contriarray,settop3contriarray]= useState([]);
const[bot3contriarray,setbot3contriarray]= useState([]);
const[Fundinfoarray,setFundinfoarray]= useState([]);

const[CMSFundinfoarray,setCMSFundinfoarray]= useState([]);
const[CMSshareinfoarray,setCMSshareinfoarray]= useState([]);


const[ShareClassarray,setShareClassarray]= useState([]);

const[monthsArrayState,setmonthsArrayState]= useState([]);
const[monthsArrayStateUSD,setmonthsArrayStateUSD]= useState([]);
const[monthsArrayStateUSDB,setmonthsArrayStateUSDB]= useState([]);
const[monthsArrayStateAEUR,setmonthsArrayStateAEUR]= useState([]);
const[monthsArrayStateBEUR,setmonthsArrayStateBEUR]= useState([]);
const[monthsArrayStateAGBP,setmonthsArrayStateAGBP]= useState([]);

const[monthlyPerformance2DArrayState,setmonthlyPerformance2DArrayState]= useState([]);
const[monthlyPerformance2DArrayStateUSD,setmonthlyPerformance2DArrayStateUSD]= useState([]);
const[monthlyPerformance2DArrayStateUSDB,setmonthlyPerformance2DArrayStateUSDB]= useState([]);
const[monthlyPerformance2DArrayStateAEUR,setmonthlyPerformance2DArrayStateAEUR]= useState([]);
const[monthlyPerformance2DArrayStateBEUR,setmonthlyPerformance2DArrayStateBEUR]= useState([]);
const[monthlyPerformance2DArrayStateAGBP,setmonthlyPerformance2DArrayStateAGBP]= useState([]);





const [RespPrtu, setRespPrtu] = useState([]);

const [PRTU, setPRTU] = useState([]);

const[arrPRTUState,setarrPRTUState]= useState([]);
const[PRTUDate,setPRTUDate]= useState([]);

const[DailyDate,setDailyDate]= useState([]);

const[Summary,setSummary]= useState([]);
const[Literature,setLiterature]= useState([]);



const[Loading,setLoading]= useState(false);

// const twelvemonPerfDiscreteAPI = []
// const top3contriarray =[]
// const bot3contriarray = []
const [status, setstatus] = useState(false);

// const [productstest, setproductstest] = useState([]);
// const {current:a} = useRef(productscommulativePerformance)
// const prevCountRef = useRef(productscommulativePerformance)
// const ABC = ""
// let XYZ = ""
// const objjj = Object.assign({}, productsbot3contr);
// const objee = Object.assign({}, objjj);

// const prevArr = usePrevious(arr);



useEffect(()=>{

  fetchMyAPI()
  
},[])

// const abc=()=>{
  

// }

const literatureButton=()=>{

let FundName;

let LiteratureName;
let FileName;
let LiteratureDate;
let LiteratureTitle;
let FinancialTrendFund;
let LiteratureSubHead;
let OtherInfoLiteratureArr=[];
let OtherSummaryInfoLiteratureArr=[];
let KeyInveInfoLiteratureArr=[];
let pressCoverageLiteratureArr=[];
let applicationsLiteratureArr=[];
let reportsLiteratureArr=[];
let offerDocumentsLiteratureArr=[];

var LiteratureKeys = ["LiteratureNameKey","FileName","LiteratureDate","LiteratureTitle"];

  for(let i=0 ; i< Literature.length ;i++){
    let OtherInfoObj={};
    let KeyInveInfoObj={};
    let pressCoverageObj={};
    let applicationsObj={};
    let reportsObj={};
    let offerDocumentsObj={};
     
    FundName = Literature[i].fund_name;
    if(FundName == "financial_trends"){
      // console.log(FundName)

    if(Literature[i].literature_name == "other_information"){

      FinancialTrendFund = FundName; 
      LiteratureTitle = Literature[i].title;
      LiteratureName = Literature[i].literature_name;
      FileName = Literature[i].file;
      LiteratureDate = Literature[i].date;

      OtherInfoObj[LiteratureKeys[0]] = LiteratureName;
      OtherInfoObj[LiteratureKeys[1]] = FileName;
      OtherInfoObj[LiteratureKeys[2]] = LiteratureDate;
      OtherInfoObj[LiteratureKeys[3]] = LiteratureTitle;

      OtherInfoLiteratureArr.push(OtherInfoObj);
    }
    if(Literature[i].literature_name == "other_information_summary"){
  
      FinancialTrendFund = FundName; 
      LiteratureTitle = Literature[i].title;
      LiteratureName = Literature[i].literature_name;
      FileName = Literature[i].file;
      LiteratureDate = Literature[i].date;

      OtherInfoObj[LiteratureKeys[0]] = LiteratureName;
      OtherInfoObj[LiteratureKeys[1]] = FileName;
      OtherInfoObj[LiteratureKeys[2]] = LiteratureDate;
      OtherInfoObj[LiteratureKeys[3]] = LiteratureTitle;

      OtherSummaryInfoLiteratureArr.push(OtherInfoObj);
    }
    if(Literature[i].literature_name == "key_investor_information"){

      FinancialTrendFund = FundName; 
      LiteratureTitle = Literature[i].title;
      LiteratureName = Literature[i].literature_name;
      FileName = Literature[i].file;
      LiteratureDate = Literature[i].date;

      KeyInveInfoObj[LiteratureKeys[0]] = LiteratureName;
      KeyInveInfoObj[LiteratureKeys[1]] = FileName;
      KeyInveInfoObj[LiteratureKeys[2]] = LiteratureDate;
      KeyInveInfoObj[LiteratureKeys[3]] = LiteratureTitle;

      KeyInveInfoLiteratureArr.push(KeyInveInfoObj);

    }
    if(Literature[i].literature_name == "press_Coverage"){

      FinancialTrendFund = FundName; 
      LiteratureTitle = Literature[i].title;
      LiteratureName = Literature[i].literature_name;
      FileName = Literature[i].file;
      LiteratureDate = Literature[i].date;

      pressCoverageObj[LiteratureKeys[0]] = LiteratureName;
      pressCoverageObj[LiteratureKeys[1]] = FileName;
      pressCoverageObj[LiteratureKeys[2]] = LiteratureDate;
      pressCoverageObj[LiteratureKeys[3]] = LiteratureTitle;

      pressCoverageLiteratureArr.push(pressCoverageObj);

    }
    if(Literature[i].literature_name == "applications"){

      FinancialTrendFund = FundName; 
      LiteratureTitle = Literature[i].title;
      LiteratureName = Literature[i].literature_name;
      FileName = Literature[i].file;
      LiteratureDate = Literature[i].date;

      applicationsObj[LiteratureKeys[0]] = LiteratureName;
      applicationsObj[LiteratureKeys[1]] = FileName;
      applicationsObj[LiteratureKeys[2]] = LiteratureDate;
      applicationsObj[LiteratureKeys[3]] = LiteratureTitle;

      applicationsLiteratureArr.push(applicationsObj);

    }
    if(Literature[i].literature_name == "reports"){

      FinancialTrendFund = FundName; 
      LiteratureTitle = Literature[i].title;
      LiteratureName = Literature[i].literature_name;
      FileName = Literature[i].file;
      LiteratureDate = Literature[i].date;

      reportsObj[LiteratureKeys[0]] = LiteratureName;
      reportsObj[LiteratureKeys[1]] = FileName;
      reportsObj[LiteratureKeys[2]] = LiteratureDate;
      reportsObj[LiteratureKeys[3]] = LiteratureTitle;

      reportsLiteratureArr.push(reportsObj);

    }
    if(Literature[i].literature_name == "offering_documents"){

      FinancialTrendFund = FundName; 
      LiteratureTitle = Literature[i].title;
      LiteratureName = Literature[i].literature_name;
      FileName = Literature[i].file;
      LiteratureDate = Literature[i].date;

      offerDocumentsObj[LiteratureKeys[0]] = LiteratureName;
      offerDocumentsObj[LiteratureKeys[1]] = FileName;
      offerDocumentsObj[LiteratureKeys[2]] = LiteratureDate;
      offerDocumentsObj[LiteratureKeys[3]] = LiteratureTitle;

      offerDocumentsLiteratureArr.push(offerDocumentsObj);

    }

    
    }
 
  }


  setFundNameState(FinancialTrendFund);
  setLiteratureDataState(OtherInfoLiteratureArr);
  setLiteratureSummaryDataState(OtherSummaryInfoLiteratureArr);
  setKeyInveInfoState(KeyInveInfoLiteratureArr);
  setPressCoverageState(pressCoverageLiteratureArr);
  setApplicationsState(applicationsLiteratureArr);
  setReportsState(reportsLiteratureArr);
  setofferDocumentState(offerDocumentsLiteratureArr);

}

const Clicked=()=>{
  $("#literatureTab").click();
  literatureButton();
  // console.log("clicked")
}
const tt=()=>{
  // alert("hi");
  $('.btn-setting')[0].click();
}
const summaryButton=()=>{
  // console.log(SessionResponse);
// console.log("Summary_SessionResponse");
tt();
var heading;
var objective;
var team;
const arrPRTU=[];
const graphDataResponse = [];
var Daily_price_date;


// For loop for calculation date
let calculation = RespPrtu[1][2]
// new Date(date).toLocaleDateString()
let daily_cal = PRTU[1][1]

let calculatedDate = new Date(calculation).toLocaleDateString("en-US", { day: 'numeric' })+ "/"+ new Date(calculation).toLocaleDateString("en-US", { month: 'numeric' })+ "/" + new Date(calculation).toLocaleDateString("en-US", { year: 'numeric' });

// console.log(new Date(calculation).toLocaleDateString("en-US", { day: 'numeric' })+ "/"+ new Date(calculation).toLocaleDateString("en-US", { month: 'numeric' })+ "/" + new Date(calculation).toLocaleDateString("en-US", { year: 'numeric' }))
// console.log("calculationcalculationcalculationcalculation")


let DailycalculatedDate = new Date(daily_cal).toLocaleDateString("en-US", { day: 'numeric' })+ "/"+ new Date(daily_cal).toLocaleDateString("en-US", { month: 'numeric' })+ "/" + new Date(daily_cal).toLocaleDateString("en-US", { year: 'numeric' });
  // for loop for Share price
  // for(let i=5;i<=11;i++){

  //   let val = PRTU[i][2]

    // console.log(val);
    // console.log("-----------------------------------ValVAL");

  //   arrPRTU.push(val)
  // }

  // console.log(arrPRTU)
  // console.log("arrPRTUarrPRTUarrPRTUarrPRTUarrPRTUarrPRTUarrPRTU");

  for(let i=0 ; i< Summary.length ;i++){
    // typeof(products[i][j])
    if(Summary[i].heading== "financial_trends"){
      heading = Summary[i].heading;
      objective = Summary[i].objective_content;  
      team = Summary[i].team_content ;
      
      //  console.log(Summary[i].team_content);
      //  console.log("Summary[0]team_content");
      }
     
      
  }

  // var allKeys = ["name","currentmonth","currency","Price","ABC","EFG","symbol","class","classDetails"];
  var allKeys = ["name", "currentmonth", "Nine", "Price", "XD_price", "currency", "nav", "shares", "nav_USD", "symbol", "class","classDetails"];
  
// var length =  products.length-1;
// console.log(PRTU);
// console.log("PRTU");

  for(let i=1 ; i< PRTU.length ;i++){
    // typeof(products[i][j])
    
    let obj={};
    for(let j =0 ;j< PRTU[i].length ;j++){

      if(!isNaN(PRTU[i][j])){
        let val = Number( PRTU[i][j] );
      // var numb= 212421434.533423131231;
      var rounded2 = Math.round((val + Number.EPSILON) * 100) / 100;

      // console.log(val);
      obj[allKeys[j]] = rounded2 ;

    }
      else{
        obj[allKeys[j]] = PRTU[i][j] ;
      }     

      }
      // console.log(obj);
      // console.log("obj------------------------");
      if(obj.currency == "GBP"){
        obj[allKeys[9]] = "£";
      }else if(obj.currency == "EUR"){
        
        obj[allKeys[9]] = "€";

      }else if(obj.currency == "USD"){
        obj[allKeys[9]] = "$";

      }

      // old logic to show fund name
      // var classShares = obj.name;
      // console.log("classShares" + classShares);
      // var classCurrency = String(classShares).split("(")
      // console.log(classCurrency)
      // console.log("classCurrency");
      // obj[allKeys[10]] = classCurrency[0];
      // obj[allKeys[11]] = classCurrency[1];
      // old logic to show fund name
      
      // new logic to show fund name in two parts, first part is the name and the second part is the 12 characters at the end of the name.
      const parts = obj.name.split(' ');
      // Check if the last part has 12 characters
      const lastPart = parts[parts.length - 1];
      if (lastPart.length === 12) {
        obj[allKeys[10]] = parts.slice(0, parts.length - 1).join(' ');
        obj[allKeys[11]] = lastPart;
      } else {
        // In case the last part doesn't have 12 characters
        obj[allKeys[10]] = obj.name;
        obj[allKeys[11]] = "";
      }


      graphDataResponse.push(obj)

}
setHeadingState(heading)
setObjectiveState(objective)
setTeamState(team)
setStateSession(SessionResponse);

setarrPRTUState(graphDataResponse);

// console.log(arrPRTUState);
// console.log("arrPRTUState");

setPRTUDate(calculatedDate)
setDailyDate(DailycalculatedDate)

  if (!graphDataResponse.length > 0) {

      
    $(".daily-price-row").css("display","none") 
  }else{
    $(".daily-price-row").css("display","block")
  }

$('.footer-container').addClass('footer-container-line')
literatureButton();
}
// $( document ).ready(function() {
    
//   if (!arrPRTUState.length > 0) {

    
//     $(".daily-price-row").css("display","none") 
//   }
//   });


const portfolioButton=()=>{


  const graphDataResponse = []
  const graphDataResponse1 = []
  const graphDataResponse2 = []
 

  var allKeys = ["name","current month","pevious month"];
  
// var length =  products.length-1;
  for(let i=1 ; i< products.length ;i++){
    // typeof(products[i][j])
    
    let obj={};
    for(let j =0 ;j< products[i].length ;j++){

      if(!isNaN(products[i][j])){
      let val = products[i][j];
      // var numb= 212421434.533423131231;
      var rounded2 = Math.round((val + Number.EPSILON) * 100) / 100;

      // console.log(rounded2);
      obj[allKeys[j]] = rounded2 ;

    }
      // var updatedVal =  parseFloat(val).toFixed(2);
      // console.log(updatedVal);
      else{
        obj[allKeys[j]] = products[i][j] ;
      }     

      }
      graphDataResponse.push(obj)
      // console.log(graphDataResponse )
    
      // setTimeout()
      

      // console.log(graphData);
      // console.log("allKeys")

      
  }

  var keysVAR = ["name", "value"]
  var length = productsVAR.length
  
    for(let i=1 ; i< length ;i++){
    
    let obj={};
    for(let j =0 ;j< productsVAR[i].length ;j++){

      if(!isNaN(productsVAR[i][j])){
      let val = productsVAR[i][j]*100;
      
      // var numb= 212421434.533423131231;
      var rounded1 = Math.round((val + Number.EPSILON) * 100) / 100;

      // console.log(rounded1);
      obj[keysVAR[j]] = rounded1 ;

    }

      // var updatedVal =  parseFloat(val).toFixed(2);
      // console.log(updatedVal);
      else{

        obj[keysVAR[j]] = productsVAR[i][j] ;
      }     

      } 

      if(obj.value !==0){
      
        graphDataResponse1.push(obj)

      }       

  }

  var keysSectorPer = ["name", "value"]
  var length = productsSectorPer.length
   for(let i=1 ; i< length ;i++){
    // typeof(products[i][j])
    
    let obj={};
    for(let j =0 ;j< productsSectorPer[i].length ;j++){

      if(!isNaN(productsSectorPer[i][j])){
      let val = productsSectorPer[i][j]*100;
      
      // var numb= 212421434.533423131231;
      var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

  
      obj[keysSectorPer[j]] = rounded ;
    }
      // var updatedVal =  parseFloat(val).toFixed(2);
      // console.log(updatedVal);
      else{
        obj[keysSectorPer[j]] = productsSectorPer[i][j] ;
      }     

    }
      if(obj.value !==0){
        graphDataResponse2.push(obj)

      }
    
  } 

  setgraphData(graphDataResponse)
  setgraphDataVAR(graphDataResponse1)
  setgraphDataSectorPer(graphDataResponse2)

  // console.log(graphDataResponse);
  // console.log("graphDataResponse");

  // console.log(graphDataResponse1);
  // console.log("graphDataResponse1");
  
  
  
  
  setportfolioStatus(true)





}


const performanceButton=()=>{


  const CummulativeperformanceData = []
  const Bot3contriData = []
  const Top3contriData = []
  const TwelvemonPerfData = []




  var keysCummulativePer = ["name", "value"]
  
   for(let i=0 ; i< productscommulativePerformance.length ;i++){
    // typeof(products[i][j])
    
    let obj={};
    for(let j =0 ;j< productscommulativePerformance[i].length ;j++){

      if(!isNaN(productscommulativePerformance[i][j])){
      let val = productscommulativePerformance[i][j]*100;
      
      // var numb= 212421434.533423131231;
      var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
      rounded =parseFloat(rounded).toFixed(2);
      
      obj[keysCummulativePer[j]] = rounded+'%' ;

    }

      // var updatedVal =  parseFloat(val).toFixed(2);
      // console.log(updatedVal);
      else{
        obj[keysCummulativePer[j]] = productscommulativePerformance[i][j] ;
      }     

      }
      CummulativeperformanceData.push(obj)
      AbcObject = obj;
      
      
      // console.log(AbcObject)
      // console.log("AbcObjectAbcObjectAbcObjectAbcObject")
    
      
      // console.log(cummulatovePerfData);
      // console.log("cummulatovePerfData");

                // console.log("allKeys")
    
  } 


  var keysbot3contr = ["name", "value"] 
  for(let i=1 ; i< productsbot3contr.length ;i++){
   
   let obj={};
       for(let j =0 ;j< productsbot3contr[i].length ;j++){

         if(!isNaN(productsbot3contr[i][j])){
         let val = productsbot3contr[i][j]*100;
        
         // var numb= 212421434.533423131231;
         var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
         rounded =parseFloat(rounded).toFixed(2);
        
         obj[keysbot3contr[j]] = rounded+'%' ;
        //  console.log(obj);
        //  console.log("obj");
       }
         else{
           obj[keysbot3contr[j]] = productsbot3contr[i][j] ;
         }     
       
         }
       
  Bot3contriData.push(obj)

 }


 
  var keystop3contr = ["name", "value"]
  for(let i=1 ; i< productstop3contr.length ;i++){
   
   let obj={};
   for(let j =0 ;j< productstop3contr[i].length ;j++){

     if(!isNaN(productstop3contr[i][j])){
     let val = productstop3contr[i][j]*100;
     
     // var numb= 212421434.533423131231;
     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
     rounded =parseFloat(rounded).toFixed(2);
    
     obj[keystop3contr[j]] = rounded+'%' ;

   }
     else{
       obj[keystop3contr[j]] = productstop3contr[i][j] ;
     }     

    }
    Top3contriData.push(obj)
   
     
    //  console.log(top3contriarray);
    //  console.log("top3contriarray");
      // console.log("allKeys")
   
 } 
 

  var keys12monthsPer = ["name", "value"]
  
  for(let i=0 ; i< products12monthsPerformance.length ;i++){
   // typeof(products[i][j])
   
   let obj={};
   for(let j =0 ;j< products12monthsPerformance[i].length ;j++){

     if(!isNaN(products12monthsPerformance[i][j])){
     let val = products12monthsPerformance[i][j]*100;
     
     // var numb= 212421434.533423131231;
     var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
     rounded =parseFloat(rounded).toFixed(2);
    
     obj[keys12monthsPer[j]] = rounded+'%' ;

   }
     else{
       obj[keys12monthsPer[j]] = products12monthsPerformance[i][j] ;
     }     

     }
     TwelvemonPerfData.push(obj)
   
 } 


 

  
  // var arr2D=[];
  
  // for(let i= 4; i<14;i++ ){
  //   let arr =[];
  //   for(let j=9; j<productsMonthlyPerf[0].length;j++ ){
  //     arr[j]=productsMonthlyPerf[j];
  //   }
  //   arr2D[i].push(arr);
  //   // arr=[];
  // }

  // console.log(arr2D);
var monthsArr=[];


  for(let i= 7; i<=21;i++ ){
    monthsArr.push(productsMonthlyPerf[3][i])
  }


  var arr2D=[];
  for(let i=4 ;i<=16;i++){
    let arr=[]
    for(let j=8 ;j<=21;j++){
      if(productsMonthlyPerf[i][j] != ""){
     let val = productsMonthlyPerf[i][j]*100;
     
     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
     rounded = parseFloat(rounded).toFixed(2);
     if(rounded ==0.00){
      rounded = 0;
    }
 
     if(isNaN(rounded)){
      rounded = 0;
     

     }
      arr.push(rounded+'%')
     
    }else{
      if(productsMonthlyPerf[i][j] === 0){
        let val1 = productsMonthlyPerf[i][j]*100;
         var rounded1 = Math.round((val1 + Number.EPSILON) * 100) / 100;
         rounded1 = parseFloat(rounded1).toFixed(2);
          if(rounded1 ==0.00){
            rounded1 = 0;
            arr.push(rounded1+'%')
          }
        }else{
            rounded = ''; 
            arr.push(rounded)
        }
      // rounded = ''; 
      // arr.push(rounded)
    }
      // arr.push(productsMonthlyPerf[i][j])
    }
    arr2D.push(arr);
  }

for(let i =0;i<arr2D.length;i++){
for(let j =0 ; j< arr2D[0].length;j++){

  // console.log(arr2D[1][j])
if(arr2D[i][j]==0+'%'){

  arr2D[i][j] = "0.00%"
}else if(arr2D[i][j]==''){

  arr2D[i][j] = " "
}
}
}



  setcummulatovePerfData(CummulativeperformanceData)
  settwelvemonPerfDiscreteAPI(TwelvemonPerfData)
  settop3contriarray(Top3contriData)
  setbot3contriarray(Bot3contriData)
  setmonthsArrayState(monthsArr)
  setmonthlyPerformance2DArrayState(arr2D)



  var monthsArrUSD=[];
 

  for(let i= 7; i<=21;i++ ){
    monthsArrUSD.push(productsMonthlyPerfUSD[3][i])
  }


  var arr2DUSD=[];
  for(let i=4 ;i<=16;i++){
    let arr=[]
    for(let j=8 ;j<=21;j++){
      if(productsMonthlyPerfUSD[i][j] != ""){
        let val = productsMonthlyPerfUSD[i][j]*100;
        
        var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
        rounded = parseFloat(rounded).toFixed(2);
        if(rounded ==0.00){
          rounded = 0;
        }
        
        if(isNaN(rounded)){
          rounded = 0;
          // console.log("rounded--------------------------rounded")

          // console.log(rounded)

        }
          arr.push(rounded+'%')
        
        }else{
          if(productsMonthlyPerfUSD[i][j] === 0){
            let val1 = productsMonthlyPerfUSD[i][j]*100;
             var rounded1 = Math.round((val1 + Number.EPSILON) * 100) / 100;
             rounded1 = parseFloat(rounded1).toFixed(2);
              if(rounded1 ==0.00){
                rounded1 = 0;
                arr.push(rounded1+'%')
              }
            }else{
                rounded = ''; 
                arr.push(rounded)
            }
          // rounded = ''; 
          // arr.push(rounded)
        }
      // arr.push(productsMonthlyPerf[i][j])
    }
    arr2DUSD.push(arr);
  }

for(let i =0;i<arr2DUSD.length;i++){
for(let j =0 ; j< arr2DUSD[0].length;j++){

  // console.log(arr2D[1][j])
if(arr2DUSD[i][j]==0+'%'){
  // console.log(arr2DUSD[i][j])
  arr2DUSD[i][j] = "0.00%"
}else if(arr2DUSD[i][j]==''){
  // console.log(arr2DUSD[i][j])
  arr2DUSD[i][j] = " "
}
}

}
  setmonthsArrayStateUSD(monthsArrUSD)
  setmonthlyPerformance2DArrayStateUSD(arr2DUSD)
  



  var monthsArrAEUR=[];
  // console.log(productsMonthlyPerfAEUR)
  // console.log("productsMonthlyPerfAEUR")

  for(let i= 7; i<=21;i++ ){
    monthsArrAEUR.push(productsMonthlyPerfAEUR[3][i])
  }
  // console.log("months")
  // console.log(monthsArrAEUR)

  var arr2DAEUR=[];
  for(let i=4 ;i<=11;i++){
    let arrAEUR=[]
    for(let j=8 ;j<=21;j++){
      if(productsMonthlyPerfAEUR[i][j] != ""){
     let val = productsMonthlyPerfAEUR[i][j]*100;
     
     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
     rounded = parseFloat(rounded).toFixed(2);
     if(rounded ==0.00){
      rounded = 0;
    }
    
     if(isNaN(rounded)){
      rounded = 0;
      // console.log("rounded--------------------------rounded")

      // console.log(rounded)

     }
     arrAEUR.push(rounded+'%')
     
    }else{
      if(productsMonthlyPerfAEUR[i][j] === 0){
        let val1 = productsMonthlyPerfAEUR[i][j]*100;
         var rounded1 = Math.round((val1 + Number.EPSILON) * 100) / 100;
         rounded1 = parseFloat(rounded1).toFixed(2);
          if(rounded1 ==0.00){
            rounded1 = 0;
            arrAEUR.push(rounded1+'%')
          }
        }else{
            rounded = ''; 
            arrAEUR.push(rounded)
        }
      // rounded = ''; 
      // arrAEUR.push(rounded)
    }
      // arr.push(productsMonthlyPerf[i][j])
    }
    arr2DAEUR.push(arrAEUR);
  }

for(let i =0;i<arr2DAEUR.length;i++){
for(let j =0 ; j< arr2DAEUR[0].length;j++){

  // console.log(arr2D[1][j])
if(arr2DAEUR[i][j]==0+'%'){
  // console.log(arr2DAEUR[i][j])
  arr2DAEUR[i][j] = "0.00%"
}else if(arr2DAEUR[i][j]==''){
  // console.log(arr2DAEUR[i][j])
  arr2DAEUR[i][j] = " "
}
}

}
  
  setmonthsArrayStateAEUR(monthsArrAEUR)
  setmonthlyPerformance2DArrayStateAEUR(arr2DAEUR)





  var monthsArrUSDB=[];
  // console.log(productsMonthlyPerfUSDB)
  // console.log("productsMonthlyPerfUSDB")

  for(let i= 7; i<=21;i++ ){
    monthsArrUSDB.push(productsMonthlyPerfUSDB[3][i])
  }
  // console.log("months")
  // console.log(monthsArrUSDB)

  var arr2DUSDB=[];
  for(let i=4 ;i<=16;i++){
    let arrB=[]
    for(let j=8 ;j<=21;j++){
      if(productsMonthlyPerfUSDB[i][j] != ""){
     let val = productsMonthlyPerfUSDB[i][j]*100;
     
     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
     rounded = parseFloat(rounded).toFixed(2);
     if(rounded ==0.00){
      rounded = 0;
    }
    
     if(isNaN(rounded)){
      rounded = 0;
      // console.log("rounded--------------------------rounded")

      // console.log(rounded)

     }
     arrB.push(rounded+'%')
    }else{
      if(productsMonthlyPerfUSDB[i][j] === 0){
        let val1 = productsMonthlyPerfUSDB[i][j]*100;
         var rounded1 = Math.round((val1 + Number.EPSILON) * 100) / 100;
         rounded1 = parseFloat(rounded1).toFixed(2);
          if(rounded1 ==0.00){
            rounded1 = 0;
            arrB.push(rounded1+'%')
          }
        }else{
            rounded = ''; 
            arrB.push(rounded)
        }
      // rounded = ''; 
      // arrB.push(rounded)
    }
      
      // arr.push(productsMonthlyPerf[i][j])
    }
    arr2DUSDB.push(arrB);
  }

for(let i =0;i<arr2DUSDB.length;i++){
for(let j =0 ; j< arr2DUSDB[0].length;j++){

  // console.log(arr2D[1][j])
if(arr2DUSDB[i][j]==0+'%'){
  // console.log(arr2DUSDB[i][j])
  arr2DUSDB[i][j] = "0.00%"
}else if(arr2DUSDB[i][j]==''){
  // console.log(arr2DUSDB[i][j])
  arr2DUSDB[i][j] = " "
}
}
}
  setmonthsArrayStateUSD(monthsArrUSDB)
  setmonthlyPerformance2DArrayStateUSDB(arr2DUSDB)
  



  var monthsArrBEUR=[];
  // console.log(productsMonthlyPerfBEUR)
  // console.log("productsMonthlyPerfBEUR")

  for(let i= 7; i<=21;i++ ){
    monthsArrBEUR.push(productsMonthlyPerfBEUR[3][i])
  }
  // console.log("months")
  // console.log(monthsArrBEUR)

  var arr2DBEUR=[];
  for(let i=4 ;i<=11;i++){
    let arrBEUR=[]
    for(let j=8 ;j<=21;j++){
      if(productsMonthlyPerfBEUR[i][j] != ""){
     let val = productsMonthlyPerfBEUR[i][j]*100;
     
     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
     rounded = parseFloat(rounded).toFixed(2);
     if(rounded ==0.00){
      rounded = 0;
    }
    
     if(isNaN(rounded)){
      rounded = 0;
      // console.log("rounded--------------------------rounded")

      // console.log(rounded)

     }
     arrBEUR.push(rounded+'%')
     
    }else{
      if(productsMonthlyPerfBEUR[i][j] === 0){
        let val1 = productsMonthlyPerfBEUR[i][j]*100;
         var rounded1 = Math.round((val1 + Number.EPSILON) * 100) / 100;
         rounded1 = parseFloat(rounded1).toFixed(2);
          if(rounded1 ==0.00){
            rounded1 = 0;
            arrBEUR.push(rounded1+'%')
          }
        }else{
            rounded = ''; 
            arrBEUR.push(rounded)
        }
      // rounded = ''; 
      // arrBEUR.push(rounded)
    }
      // arr.push(productsMonthlyPerf[i][j])
    }
    arr2DBEUR.push(arrBEUR);
  }

for(let i =0;i<arr2DBEUR.length;i++){
for(let j =0 ; j< arr2DBEUR[0].length;j++){

  // console.log(arr2D[1][j])
if(arr2DBEUR[i][j]==0+'%'){
  // console.log(arr2DBEUR[i][j])
  arr2DBEUR[i][j] = "0.00%"
}else if(arr2DBEUR[i][j]==''){
  // console.log(arr2DBEUR[i][j])
  arr2DBEUR[i][j] = " "
}
}
}
  
  setmonthsArrayStateBEUR(monthsArrBEUR)
  setmonthlyPerformance2DArrayStateBEUR(arr2DBEUR)




  var monthsArrAGBP=[];
  // console.log(productsMonthlyPerfAGBP)
  // console.log("productsMonthlyPerfAGBP")

  for(let i= 7; i<=21;i++ ){
    monthsArrAGBP.push(productsMonthlyPerfAGBP[3][i])
  }
  // console.log("months")
  // console.log(monthsArrAGBP)

  var arr2DAGBP=[];
  for(let i=4 ;i<=15;i++){
    let arrBEUR=[]
    for(let j=8 ;j<=21;j++){
      if(productsMonthlyPerfAGBP[i][j] != ""){
     let val = productsMonthlyPerfAGBP[i][j]*100;
     
     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
     rounded = parseFloat(rounded).toFixed(2);
     if(rounded ==0.00){
      rounded = 0;
    }
    
     if(isNaN(rounded)){
      rounded = 0;
      // console.log("rounded--------------------------rounded")

      // console.log(rounded)

     }
     arrBEUR.push(rounded+'%')
    }else{
      if(productsMonthlyPerfAGBP[i][j] === 0){
        let val1 = productsMonthlyPerfAGBP[i][j]*100;
         var rounded1 = Math.round((val1 + Number.EPSILON) * 100) / 100;
         rounded1 = parseFloat(rounded1).toFixed(2);
          if(rounded1 ==0.00){
            rounded1 = 0;
            arrBEUR.push(rounded1+'%')
          }
        }else{
            rounded = ''; 
            arrBEUR.push(rounded)
        }

    }
     
      
      // arr.push(productsMonthlyPerf[i][j])
    }
    arr2DAGBP.push(arrBEUR);
  }

for(let i =0;i<arr2DAGBP.length;i++){
for(let j =0 ; j< arr2DAGBP[0].length;j++){

  // console.log(arr2D[1][j])
if(arr2DAGBP[i][j]==0+'%'){
  // console.log(arr2DAGBP[i][j])
  arr2DAGBP[i][j] = "0.00%"
}
}
// console.log("--------------------------------------------------------------------")
}
  
  setmonthsArrayStateAGBP(monthsArrAGBP)
  setmonthlyPerformance2DArrayStateAGBP(arr2DAGBP)
}


const informationButton=()=>{
  const shareClassData =[]
  const fundInfoData =[]
  
  const CMSfundInfoData =[]
  const CMSshareInfoData =[]

  
  var keysShareClass = ["name", "value","currency"]
  
  for(let i=0 ; i< productsShareClass.length ;i++){
   // typeof(products[i][j])
   
   let obj={};
   for(let j =0 ;j< productsShareClass[i].length ;j++){

     if(!isNaN(productsShareClass[i][j])){
     let val = productsShareClass[i][j];
     
     // var numb= 212421434.533423131231;
     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

    
     obj[keysShareClass[j]] = rounded.toString().replace(/(^\d{1,3}|\d{3})(?=(?:\d{3})+(?:$|\.))/g, '$1,') ;
    //  console.log(obj);
    //  console.log("obj");
   }

     // var updatedVal =  parseFloat(val).toFixed(2);
     // console.log(updatedVal);
     else{
       obj[keysShareClass[j]] = productsShareClass[i][j] ;
     }     
     if(obj.name == "A GBP" || obj.name=="B GBP"){
      obj[keysShareClass[2]] = "£";
    }else if(obj.name == "A EUR" || obj.name == "B EUR"){
      obj[keysShareClass[2]] = "€";
    }else if(obj.name == "A USD" || obj.name == "B USD"){
      obj[keysShareClass[2]] = "$";
    }
     }
     shareClassData.push(obj)
   
     
 }  


  var keysFundinfo = ["name", "value"]
  
  for(let i=1 ; i< productsFundinfo.length ;i++){
   // typeof(products[i][j])
   
   let obj={};
   for(let j =0 ;j< productsFundinfo[i].length ;j++){

     if(!isNaN(productsFundinfo[i][j])){
     let val = productsFundinfo[i][j]*100;
     
     // var numb= 212421434.533423131231;
     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
     var mrounded = Math.round((productsFundinfo[i][j] + Number.EPSILON) * 100) / 100;
    
     obj[keysFundinfo[j]] = rounded.toString().replace(/(^\d{1,3}|\d{3})(?=(?:\d{3})+(?:$|\.))/g, '$1,') ;
    //  console.log(obj);
    //  console.log("obj");
     if(mrounded > 1000000){
      var million_variable = (mrounded/1000000).toFixed(2) + 'm'
    
      obj[keysFundinfo[j]] = 'US$ '+ million_variable;
    
      }else if(typeof rounded === "number"){
        obj[keysFundinfo[j]] = rounded+'%'

      }
      
    }
   else{
          obj[keysFundinfo[j]] = productsFundinfo[i][j] ;
        }     

     }
     fundInfoData.push(obj)
   

 }


 var keysCMSFundinfo = ["name", "value"]
  
   for(let j =0 ;j< CMSFundinfo.length ;j++){
    // console.log(CMSFundinfo[j].title);
    // console.log("CMSFundinfo.title");

    let obj={};

    // KeyInveInfoObj[LiteratureKeys[0]] = LiteratureName;

       obj[keysCMSFundinfo[0]] = CMSFundinfo[j].title ;
       obj[keysCMSFundinfo[1]] = CMSFundinfo[j].value ;
     

    //  console.log(obj);
    //  console.log("obj---------------@");

     CMSfundInfoData.push(obj)
     }

 var keysCMSshareinfo = ["name", "ausdValue","agbpValue","aeurValue","busdValue","bgbpValue","beurValue"]
  
     for(let j =0 ;j< CMSshareinfo.length ;j++){
      // console.log(CMSshareinfo[j].title);
      // console.log("CMSFundinfo.title");
  
      let obj={};
   
         obj[keysCMSshareinfo[0]] = CMSshareinfo[j].title ;
         obj[keysCMSshareinfo[1]] = CMSshareinfo[j].ausd_value ;
         obj[keysCMSshareinfo[2]] = CMSshareinfo[j].agbp_value ;
         obj[keysCMSshareinfo[3]] = CMSshareinfo[j].aeur_value ;
         obj[keysCMSshareinfo[4]] = CMSshareinfo[j].busd_value ;
         obj[keysCMSshareinfo[5]] = CMSshareinfo[j].bgbp_value ;
         obj[keysCMSshareinfo[6]] = CMSshareinfo[j].beur_value ;

  
      //  console.log(obj);
      //  console.log("obj---------------@");
  
       CMSshareInfoData.push(obj)
       }

   
//  }

 setShareClassarray(shareClassData)
 setFundinfoarray(fundInfoData)
 setCMSFundinfoarray(CMSfundInfoData)
 setCMSshareinfoarray(CMSshareInfoData)











}



$(document).ready(function() {
    

  // document.getElementById("summaryButton").click()
});  




let AbcObject ={};

let count = 0;
async function fetchMyAPI(){
  // fetchSessionUserAPI();


// const fetchMyAPI = useCallback(() => {
  // https://epicipprojects.com/getdata  
  // https://jsonplaceholder.typicode.com/posts
  const localurl ='https://www.epicip.com/epic-financial-trends';
  const url = config.apiPath + '/epic-financial-trends' 
  //const url = 'https://www.epicip.com/epic-financial-trends';
   // const url = 'http://127.0.0.1:8000/epic-financial-trends'
  
  // const url =config.apiPath + "/api/garraway-financial-trends"
  fetch(config.apiPath + '/session_data').then(resp => resp.json()).then(resp =>  {
    


    setSessionResponse(resp);

})

   fetch(url).then(resp=> resp.json())
   .then (resp => {

    setProducts(resp.SectorExposures)
    setProductsVAR(resp.SectorVaR)
    setProductsSectorPer(resp.SectorPerformance)
    setproductscommulativePerformance(resp.CumulativePerf)
    setproducts12monthsPerformance(resp.twelvemPerfDiscrete)
    setproductstop3contr(resp.Top3Contributors)
    setproductsbot3contr(resp.Bottom3Contributors)
    setproductsCommentary(resp.content)
    setproductsFundinfo(resp.FundInfo)
    setproductsShareClass(resp.NAVperShare)
    setproductsMonthlyPerf(resp.MonthlyPerfBGBP)
    setproductsMonthlyPerfUSD(resp.MonthlyPerfAUSD)
    setproductsMonthlyPerfUSDB(resp.MonthlyPerfBUSD)
    setproductsMonthlyPerfAEUR(resp.MonthlyPerfAEUR)
    setproductsMonthlyPerfBEUR(resp.MonthlyPerfBEUR)
    setproductsMonthlyPerfAGBP(resp.MonthlyPerfAGBP)
    setRespPrtu(resp.prtu)
    setPRTU(resp.daily_price)
    setSummary(resp.summary)
    setLiterature(resp.literature)
    setCMSFundinfo(resp.fund_info)
    setCMSshareinfo(resp.shareinfo)
    // setLoading(true)
    setstatus(true)
    // setSessionResponse(sessionresp);
    document.getElementById("summaryButton").click();
    document.getElementsByClassName('btn-setting').click();

    })
    
   .catch(e=>{
    //  console.log(e);
   })

  // setresponseData(result)
  // .then( resp=>console.log(resp.SectorExposures))
  
  // console.log(responseData)
  // console.log("responseData")

  var keysMonthly = ["name"]
  var testArr =[]
  var monthsValue =[[],[]]
  var xArr =[[]]
  // var xArr = new Array(10);

  // for (var i = 0; i < xArr.length; i++) {
  //   xArr[i] = new Array(14);
  // }
  

//   for(let y = 4; y < 13; y++){

//     var count = 0;
//     var moreCount = 0;  

//     for(let z = 8; z < 22; z++){

//       xArr[count][moreCount]= productsMonthlyPerf[y][z]
//       // xArr.push(productsMonthlyPerf[y][z])

//       moreCount++;
//     }
//     count++;


//   }
//   console.log(xArr);
//   console.log("xArr");

//   for(let x= 8; x < 22; x++){

//   testArr.push(productsMonthlyPerf[3][x])

// }
// console.log(testArr)
// console.log("testArr")


//   for(let i=3 ; i< 14;i++){
//    // typeof(products[i][j])
   
//    let obj={};
//    for(let j = 8 ;j< 22 ;j++){

//      if(!isNaN(productsMonthlyPerf[i][j])){
       
//      let val = productsMonthlyPerf[i][j]*100;
    //  console.log(productsMonthlyPerf[i][j])
//      console.log("productsMonthlyPerf[i][j]productsMonthlyPerf[i][j]productsMonthlyPerf[i][j]productsMonthlyPerf[i][j]productsMonthlyPerf[i][j]productsMonthlyPerf[i][j]productsMonthlyPerf[i][j]productsMonthlyPerf[i][j]productsMonthlyPerf[i][j]")

//      // var numb= 212421434.533423131231;
//      var rounded = Math.round((val + Number.EPSILON) * 100) / 100;





//      obj[keysMonthly[j]] = rounded ;
//      console.log(obj);
//      console.log("obj");
//    }

//      // var updatedVal =  parseFloat(val).toFixed(2);
//      // console.log(updatedVal);
//      else{
//        obj[keysMonthly[j]] = productsMonthlyPerf[i][j] ;
//      }     

//      }
//     //  ShareClassarray.push(obj)
   
     
//     //  console.log(bot3contriarray);
//     //  console.log("bot3contriarray");
//     //  console.log(bot3contriDummy);
//     //  console.log("bot3contriDummy");

//                // console.log("allKeys")
//  }  

// For loops for displaying data
//   var keysShareClass = ["name", "value"]
  
//   for(let i=0 ; i< productsShareClass.length ;i++){
//    // typeof(products[i][j])
   
//    let obj={};
//    for(let j =0 ;j< productsShareClass[i].length ;j++){

//      if(!isNaN(productsShareClass[i][j])){
//      let val = productsShareClass[i][j]*100;
     
//      // var numb= 212421434.533423131231;
//      var rounded = Math.round((val + Number.EPSILON) * 100) / 100;


//      obj[keysShareClass[j]] = rounded ;
//      console.log(obj);
//      console.log("obj");
//    }

//      // var updatedVal =  parseFloat(val).toFixed(2);
//      // console.log(updatedVal);
//      else{
//        obj[keysShareClass[j]] = productsShareClass[i][j] ;
//      }     

//      }
//      ShareClassarray.push(obj)
   
     
//      console.log(bot3contriarray);
//      console.log("bot3contriarray");
//      console.log(bot3contriDummy);
//      console.log("bot3contriDummy");

//                // console.log("allKeys")
//  }  


//   var keysFundinfo = ["name", "value"]
  
//   for(let i=0 ; i< productsFundinfo.length ;i++){
//    // typeof(products[i][j])
   
//    let obj={};
//    for(let j =0 ;j< productsFundinfo[i].length ;j++){

//      if(!isNaN(productsFundinfo[i][j])){
//      let val = productsFundinfo[i][j]*100;
     
//      // var numb= 212421434.533423131231;
//      var rounded = Math.round((val + Number.EPSILON) * 100) / 100;


//      obj[keysFundinfo[j]] = rounded ;
//      console.log(obj);
//      console.log("obj");
//    }

//      // var updatedVal =  parseFloat(val).toFixed(2);
//      // console.log(updatedVal);
//      else{
//        obj[keysFundinfo[j]] = productsFundinfo[i][j] ;
//      }     

//      }
//      Fundinfoarray.push(obj)
   
     
//      console.log(Fundinfoarray);
//      console.log("Fundinfoarray");

//  }




//   var keysbot3contr = ["name", "value"]
  
//   for(let i=0 ; i< productsbot3contr.length ;i++){
//    // typeof(products[i][j])
   
//    let obj={};
//    for(let j =0 ;j< productsbot3contr[i].length ;j++){

//      if(!isNaN(productsbot3contr[i][j])){
//      let val = productsbot3contr[i][j]*100;
     
//      // var numb= 212421434.533423131231;
//      var rounded = Math.round((val + Number.EPSILON) * 100) / 100;


//      obj[keysbot3contr[j]] = rounded ;
//      console.log(obj);
//      console.log("obj");
//    }

//      // var updatedVal =  parseFloat(val).toFixed(2);
//      // console.log(updatedVal);
//      else{
//        obj[keysbot3contr[j]] = productsbot3contr[i][j] ;
//      }     

//      }
//      bot3contriarray.push(obj)
   
     
//      console.log(bot3contriarray);
//      console.log("bot3contriarray");
//      console.log(bot3contriDummy);
//      console.log("bot3contriDummy");

//                // console.log("allKeys")
//  }
// //  bot3contriDummy = [
// //   {name: 'Short Euro / Swiss Franc', value: -0.34},
// //   {name: 'Short Norwegian Krone / US Dollar', value: -0.31},
// //   {name: 'Long Italian BTP', value: -0.29}
// //  ]

 
// //  bot3contriarray.push(productsbot3contr)

// //  console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx")
// //  console.log(productsbot3contr)



 
//   var keystop3contr = ["name", "value"]
  
//   for(let i=1 ; i< productstop3contr.length ;i++){
//    // typeof(products[i][j])
   
//    let obj={};
//    for(let j =0 ;j< productstop3contr[i].length ;j++){

//      if(!isNaN(productstop3contr[i][j])){
//      let val = productstop3contr[i][j]*100;
     
//      // var numb= 212421434.533423131231;
//      var rounded = Math.round((val + Number.EPSILON) * 100) / 100;


//      obj[keystop3contr[j]] = rounded ;

//    }

//      // var updatedVal =  parseFloat(val).toFixed(2);
//      // console.log(updatedVal);
//      else{
//        obj[keystop3contr[j]] = productstop3contr[i][j] ;
//      }     

//      }
//      top3contriarray.push(obj)
   
     
//      console.log(top3contriarray);
//      console.log("top3contriarray");
//       // console.log("allKeys")
   
//  } 
 

//   var keys12monthsPer = ["name", "value"]
  
//   for(let i=0 ; i< products12monthsPerformance.length ;i++){
//    // typeof(products[i][j])
   
//    let obj={};
//    for(let j =0 ;j< products12monthsPerformance[i].length ;j++){

//      if(!isNaN(products12monthsPerformance[i][j])){
//      let val = products12monthsPerformance[i][j]*100;
     
//      // var numb= 212421434.533423131231;
//      var rounded = Math.round((val + Number.EPSILON) * 100) / 100;


//      obj[keys12monthsPer[j]] = rounded ;

//    }

//      // var updatedVal =  parseFloat(val).toFixed(2);
//      // console.log(updatedVal);
//      else{
//        obj[keys12monthsPer[j]] = products12monthsPerformance[i][j] ;
//      }     

//      }
//      twelvemonPerfDiscreteAPI.push(obj)
   
     
//      console.log(twelvemonPerfDiscreteAPI);
//      console.log("twelvemonPerfDiscreteAPI");

//                // console.log("allKeys")
   
//  } 

  // var keysCummulativePer = ["name", "value"]
  
  //  for(let i=0 ; i< productscommulativePerformance.length ;i++){
  //   // typeof(products[i][j])
    
  //   let obj={};
  //   for(let j =0 ;j< productscommulativePerformance[i].length ;j++){

  //     if(!isNaN(productscommulativePerformance[i][j])){
  //     let val = productscommulativePerformance[i][j]*100;
      
  //     // var numb= 212421434.533423131231;
  //     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

  
  //     obj[keysCummulativePer[j]] = rounded ;

  //   }

  //     // var updatedVal =  parseFloat(val).toFixed(2);
  //     // console.log(updatedVal);
  //     else{
  //       obj[keysCummulativePer[j]] = productscommulativePerformance[i][j] ;
  //     }     

  //     }
  //     cummulatovePerfData.push(obj)
  //     AbcObject = obj;
      
      
  //     console.log(AbcObject)
  //     console.log("AbcObjectAbcObjectAbcObjectAbcObject")
    
      
  //     console.log(cummulatovePerfData);
  //     console.log("cummulatovePerfData");

  //               // console.log("allKeys")
    
  // } 



  // var keysSectorPer = ["name", "value"]
  
  //  for(let i=1 ; i< productsSectorPer.length ;i++){
  //   // typeof(products[i][j])
    
  //   let obj={};
  //   for(let j =0 ;j< productsSectorPer[i].length ;j++){

  //     if(!isNaN(productsSectorPer[i][j])){
  //     let val = productsSectorPer[i][j]*100;
      
  //     // var numb= 212421434.533423131231;
  //     var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

  
  //     obj[keysSectorPer[j]] = rounded ;

  //   }

  //     // var updatedVal =  parseFloat(val).toFixed(2);
  //     // console.log(updatedVal);
  //     else{
  //       obj[keysSectorPer[j]] = productsSectorPer[i][j] ;
  //     }     

  //     }
  //     graphDataSectorPer.push(obj)
    
      
  //     console.log(graphDataSectorPer);
  //               // console.log("allKeys")
    
  // } 
  
  
  // var keysVAR = ["name", "value"]

  //  for(let i=1 ; i< productsVAR.length ;i++){
  //   // typeof(products[i][j])
    
  //   let obj={};
  //   for(let j =0 ;j< productsVAR[i].length ;j++){

  //     if(!isNaN(productsVAR[i][j])){
  //     let val = productsVAR[i][j]*100;
      
  //     // var numb= 212421434.533423131231;
  //     var rounded1 = Math.round((val + Number.EPSILON) * 100) / 100;

  //     console.log(rounded1);
  //     obj[keysVAR[j]] = rounded1 ;

  //   }

  //     // var updatedVal =  parseFloat(val).toFixed(2);
  //     // console.log(updatedVal);
  //     else{
  //       obj[keysVAR[j]] = productsVAR[i][j] ;
  //     }     

  //     } 
  //     graphDataVAR.push(obj)
  //     setstatus(true)
  //     // console.log(graphData);
  //     // console.log("allKeys")
      
  // }


  
  
  // var allKeys = ["name","current month","pevious month"];
  
  // for(let i=1 ; i< products.length ;i++){
  //   // typeof(products[i][j])
    
  //   let obj={};
  //   for(let j =0 ;j< products[i].length ;j++){

  //     if(!isNaN(products[i][j])){
  //     let val = products[i][j];
  //     // var numb= 212421434.533423131231;
  //     var rounded2 = Math.round((val + Number.EPSILON) * 100) / 100;

  //     console.log(rounded2);
  //     obj[allKeys[j]] = rounded2 ;

  //   }
  //     // var updatedVal =  parseFloat(val).toFixed(2);
  //     // console.log(updatedVal);
  //     else{
  //       obj[allKeys[j]] = products[i][j] ;
  //     }     

  //     }
  //     graphData.push(obj)
      
  //     // console.log(graphData);
  //     // console.log("allKeys")
      
  // }
      // console.log(graphData);

      // console.log("allKeys")
};

// const dat = useMemo(()=>(AbcObject),[])





const players =[
  {
    position:"forward",
    name:"Lebron",
    team:"Lakers"
  },
  {
    position:"forward",
    name:"Lebron",
    team:"Lakers"
  },
  {
    position:"forward",
    name:"Lebron",
    team:"Lakers"
  },
  {
    position:"forward",
    name:"Lebron",
    team:"Lakers"
  }
]

const cummulatovePerfDatadummy =[
  {
    "name" : "Class B GBP",
     "value" : "Cumulative Performance"
  },
  {
      "name": "1m",
      "value": -1.29
  },
  {
      "name": "1Yr",
      "value": 1.04
  },
  {
      "name": "3Yr",
      "value": -2.41
  },
  {
      "name": "5Yr",
      "value": -19.6

  },
  {
      "name": "Since UCITS Strategy Relaunch",
      "value": 19.08
  },
  {
      "name": "Since Inception",
      "value": -3.37
  }
]

const twelvemonPerfDatadummy =[
  {
    "name" : "Class B GBP",
    "value" : "Discrete Performance"
  },

  {
        "name": "30/06/2016 - 30/06/2017",
        "value": -5.09
    },
    {
        "name": "30/06/2017 - 30/06/2018",
        "value": -13.35
    },
    {
        "name": "30/06/2018 - 30/06/2019",
        "value": 2.26
    },
    {
        "name": "30/06/2019 - 30/06/2020",
        "value": -4.85
    },
    {
        "name": "30/06/2020 - 30/06/2021",
        "value": 3.5
    }
]

const top3contriDummy = [
  {
      "name": "Long ASX SPI 200 Index",
      "value": 0.41,
      "undefined": 100
  },
  {
      "name": "Long S&P 500 Index",
      "value": 0.33,
      "undefined": 200
  },
  {
      "name": "Short Australian Dollar / New Zealand Dollar",
      "value": 0.3,
      "undefined": 300
  }
]
// $(".accordion__item__header").on("click", function(event){    
    
//   if(!$(this).hasClass("active")){
      
//       $(".accordion__item__header.active").removeClass("active");   
//       $(".collapse.show").removeClass("show");
//       $(this).addClass("active")
//       $(this).next(".collapse").addClass("show")

//   }

// })



if ($(".accordion__item__header").length > 0) {
  
  var active = "active";
  var activedis = "active-dis";
  $(".accordion__item__header").on("click", function (event) {
    event.stopImmediatePropagation();
    // console.log("clicked")
    $(this).toggleClass(active);
    $(this).find(".navlink").toggleClass(activedis);
    
  $(this).next("div").slideToggle(200);
  });
  }

  // var user_session_id ;
  async function fetchSessionUserAPI(){

    const Localurl = 'https://epicipprojects.com/session_data'
  const url = config.apiPath + '/session_data' 
     
     fetch(url).then(resp=> resp.json())
     .then (resp => {
        //  console.log(count)
        //  console.log("count")
  
        // console.log(SessionData.email);
        // console.log("resp session");
      
        setSessionResponse(resp);
        // user_session_id = resp
        // UserResponse SessionUserResponse  
      // console.log(user_session_id);
      // console.log("user_session_id");

        // console.log(SessionResponse);
      // console.log(resp);
      // console.log("resp from session API");
      })
      
     .catch(e=>{
      //  console.log(e);
     })
  };

  function renderDailyPrices(DailyPrice, index) {
    if (DailyPrice.Price !== 0) {
      return (
        <div key={index} className="DailyPricing__DailyPriceCard-sc-62f3gi-1 coIgZR">
          <div className="DailyPricing__DailyPrice-sc-62f3gi-2 gsZde">
            {DailyPrice.symbol}{DailyPrice.Price}
          </div>
          <div className="DailyPricing__DailyPriceName-sc-62f3gi-3 iLShEo">
            {DailyPrice.class}
            <br />
            <span className="daily-span">{DailyPrice.classDetails}</span>
            {/* <span className="daily-span">({DailyPrice.classDetails})</span> */}
          </div>
        </div>
      );
    }
    return null; // Return null if Price is 0, so nothing is rendered for that item
  }
  

  const CustomizedAxisTick = ({ x, y, stroke, payload }) => {

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={30} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-10)">
          {payload.value}
        </text>
      </g>
    );
};
function renderLiteratureData(data, index){
 
  return(

              <div className="col-sm-6">
                {/* <h5>{data.LiteratureNameKey}</h5>   */}
    			      <p className="pdf_download"><a href={config.apiPath + "/storage/literature-file/"+data.FileName} download target="_blank">{data.LiteratureTitle}<br/><span className="date">{data.LiteratureDate}</span></a></p>
				      </div>
  )
}

function renderLiteratureDataPO(data, index){
  return(

              <div className="col-sm-12" style={{ paddingLeft:"0px",paddingRight:"0px"}}>
                          <p className="pdf_download"><a href={config.apiPath + "/storage/literature-file/"+data.FileName} target="_blank" download>{data.LiteratureTitle}</a></p>
                      </div>
  )
}
function renderLiteratureDataRecent(data, index){
  if(index <= 1){
    return(

                <div className="col-sm-6">
                            <p className="pdf_download"><a href={config.apiPath + "/storage/literature-file/"+data.FileName} target="_blank" download>{data.LiteratureTitle}<br/><span className="date">{data.LiteratureDate}</span></a></p>
                        </div>
    )
  }
}

// productscommulativePerformance
function renderCummulativePerformanceNames(cummulatove, index) {
 if(index == 0){
  return(
      
    <th>{cummulatove.value}</th>

)   
 }else{
  return(
      
        <th>{cummulatove.name}</th>
  
  )}
}
function renderCummulativePerformanceValue(cummulatove, index) {
  if(index==0){
    return(
      <td>{cummulatove.name}</td>

)
  }else{
  return(
        <td>{cummulatove.value}</td>
  
  )}
}
function rendertwelvemonPerfDiscreteAPINames(twelvemon, index){
  if(index==0){
    return(
    <th>{twelvemon.value}</th>
    )
  }else{
    return(
    <th>{twelvemon.name}</th>
)}
}
function rendertwelvemonPerfDiscreteAPIValue(twelvemon, index){
  if(index==0){
  return(
    <th>{twelvemon.name}</th>
  )
  }else{
  return(
    <th>{twelvemon.value}</th>
)}
}
// function renderDailyPrices(DailyPrice, index){
//   if(DailyPrice.Price !== 0){
//   return(
//     <div className="DailyPricing__DailyPriceCard-sc-62f3gi-1 coIgZR">
//       <div className="DailyPricing__DailyPrice-sc-62f3gi-2 gsZde">${DailyPrice.Price}</div>
//       <div className="DailyPricing__DailyPriceName-sc-62f3gi-3 iLShEo">Class A<br/><span className="daily-span">(USD) Shares</span></div>
//   </div>
//   )
// }
// }

function rendertop3contri(top3contriparam, index){
  return(
    <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ" key={index}>
      <td className="contri-td align-left" style={{height: "52px"}}>{top3contriparam.name}</td>
      <td className="contri-td align-right" style={{height: "52px"}}>{top3contriparam.value}</td>
    </tr>
  )
}
function renderMonthNames(months, index){
  return(

    <th>{months}</th>
)
}
function render12MonthsData(bot3contriparam, index){
    // alert(bot3contriparam.name);
  for( let i=0; i< bot3contriparam.length; i++){
    return(
      <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ" key={index}>

        <td>{bot3contriparam[0].toString().slice(0,4)}</td>
        <td>{bot3contriparam[1]}</td>
        <td>{bot3contriparam[2]}</td>
        <td>{bot3contriparam[3]}</td>
        <td>{bot3contriparam[4]}</td>
        <td>{bot3contriparam[5]}</td>
        <td>{bot3contriparam[6]}</td>
        <td>{bot3contriparam[7]}</td>
        <td>{bot3contriparam[8]}</td>
        <td>{bot3contriparam[9]}</td>
        <td>{bot3contriparam[10]}</td>
        <td>{bot3contriparam[11]}</td>
        <td>{bot3contriparam[12]}</td>
        <td>{bot3contriparam[13]}</td>
    
        {/* <td>{bot3contriparam.value}</td> */}
      </tr>
    )
  }
}
function renderbot3contri(bot3contriparam, index){
  // alert(bot3contriparam.name);

  return(
    <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ" key={index}>
      
      <td className="contri-td align-left" style={{height: "52px"}}>{bot3contriparam.name}</td>
      <td className="contri-td align-right" style={{height: "52px"}}>{bot3contriparam.value}</td>
    </tr>
  )
}

function renderFundinfo(fundinfoparam, index){
  // alert(bot3contriparam.name);

  return(
    <tr className="FundInformation__Row-sc-18irt95-2 fweCQL" key={index}>
      
      <td className="align-left">{fundinfoparam.name}</td>
      <td className="align-center">{fundinfoparam.value}</td>
    </tr>
  )
}
function renderCMSshareinfo(shareinfoparam, index){
  // alert(bot3contriparam.name);
if(index ==2){
  return(
 <tr className="Shares__Row-sc-1brks4f-2 eoQrEv" key={index}>
      
  <td className="align-left">{shareinfoparam.name}</td>
  {shareinfoparam.ausdValue ?
  <td className="align-center" colSpan="3">{shareinfoparam.ausdValue}</td>:""}
  {shareinfoparam.agbpValue ?
  <td className="align-center">{shareinfoparam.agbpValue}</td> : ""}
  {shareinfoparam.aeurValue ? 
  <td className="align-center">{shareinfoparam.aeurValue}</td> : ""}
  {shareinfoparam.busdValue ?
  <td className="align-center" colSpan="3">{shareinfoparam.busdValue}</td> :""}
  {shareinfoparam.bgbpValue ? 
  <td className="align-center">{shareinfoparam.bgbpValue}</td> :""}
  {shareinfoparam.beurValue ? 
  <td className="align-center">{shareinfoparam.beurValue}</td>:""}

</tr>
  )
}else if(index ==3){
  return(
    <tr className="Shares__Row-sc-1brks4f-2 eoQrEv" key={index}>
         
     <td className="align-left">{shareinfoparam.name}</td>
     {shareinfoparam.ausdValue ?
     <td className="align-center" colSpan="6">{shareinfoparam.ausdValue}</td>:""}
     {shareinfoparam.agbpValue ?
     <td className="align-center">{shareinfoparam.agbpValue}</td> : ""}
     {shareinfoparam.aeurValue ? 
     <td className="align-center">{shareinfoparam.aeurValue}</td> : ""}
     {shareinfoparam.busdValue ?
     <td className="align-center">{shareinfoparam.busdValue}</td> :""}
     {shareinfoparam.bgbpValue ? 
     <td className="align-center">{shareinfoparam.bgbpValue}</td> :""}
     {shareinfoparam.beurValue ? 
     <td className="align-center">{shareinfoparam.beurValue}</td>:""}
   
   </tr>
     )
}else{
  return(
    <tr className="Shares__Row-sc-1brks4f-2 eoQrEv" key={index}>
      
      <td className="align-left">{shareinfoparam.name}</td>
      <td className="align-center">{shareinfoparam.ausdValue}</td>
      {shareinfoparam.agbpValue ?
      <td className="align-center">{shareinfoparam.agbpValue}</td> : ""}
      {shareinfoparam.aeurValue ? 
      <td className="align-center">{shareinfoparam.aeurValue}</td> : ""}
      {shareinfoparam.busdValue ?
      <td className="align-center">{shareinfoparam.busdValue}</td> :""}
      {shareinfoparam.bgbpValue ? 
      <td className="align-center">{shareinfoparam.bgbpValue}</td> :""}
      {shareinfoparam.beurValue ? 
      <td className="align-center">{shareinfoparam.beurValue}</td>:""}
    
    </tr>
  )
      }
}

// var keysCMSshareinfo = ["name", "ausdValue","agbpValue","aeurValue","busdValue","bgbpValue","beurValue"]

function renderShareClassNames(shareClass, index){
 if(index ==0){
  return(
    <th className="align-left">{shareClass.name}</th>


    )}else{
 
  return(
    <th className="align-center">{shareClass.name}</th>


)}
}
function renderShareClassValue(shareClassValue, index){
  if(index == 0){
    return(
    
      <td className="align-left">{shareClassValue.value}</td>
  )   
  }else{
  return(
    
    <td className="align-center">{shareClassValue.currency}{shareClassValue.value}</td>
)
}
}


function previewData(formData) {

  /* Add return before formData.map */
  return formData.map((item, key) => {
    //  console.log("item", item.name);
     return (
      <td>{item.name}</td>

      //  <div>{item.value}</div>
     )
   })
 }


    return (
      <Fragment>

    { status === true ? 
    

          
          /* <div className="accordion__item">
              
            <div className="accordion__item__header" >Fixed Income  </div>
            <div className="accordion__item__content">
              <ul>
                <li>
                  <a href="#">EPIC UCITS - NFA Global Bond Fund UI <span className="fa fa-angle-right"></span></a>
                </li>
                <li>
                  <a href="#">EPIC UCIT - Next Generation Global Bond Fund UI <span className="fa fa-angle-right"></span></a>
                </li>
              </ul>
            </div>

          </div> */

        /* <Accordion >




<Card className="accordion__card">

    <Card.Header className="accordion__item__header">
      <Accordion.Toggle as={Button} className="accordion-button"  variant="link" eventKey="1">
        Managed Futures
      </Accordion.Toggle>
    </Card.Header>

    <Accordion.Collapse eventKey="1">

      <Card.Body>

        <NavLink to="/market/EpicfinanceTrends" className="navlink a">EPIC Financial Trends <span className="fa fa-angle-right"></span></NavLink><br/>

      </Card.Body>

    </Accordion.Collapse>
</Card>



<Card className="accordion__card">

  <Card.Header className="accordion__item__header">
    <Accordion.Toggle as={Button} className="accordion-button" variant="link" eventKey="2">
      Equities
    </Accordion.Toggle>
  </Card.Header>
          
  <Accordion.Collapse eventKey="2">
          
    <Card.Body>

    <NavLink to="/market/EpicglobalEquity" className="navlink a">Epicip Global Equity Fund</NavLink><br/>
      <NavLink to="/market/EpicorientalFocus" className="navlink a">Epicip Oriental Focus Fund</NavLink><br/>
      <NavLink to="/market/EpicAsianCentricGlobalGrowth" className="navlink a">Epicip Asian Centric Global Growth Fund</NavLink><br/>
      <NavLink to="/market/EpicUKEquityMarketFund" className="navlink a">Epicip UK Equity Market Fund</NavLink><br/>

    
    </Card.Body>
          
  </Accordion.Collapse>
  </Card>

  <Card className="accordion__card">

    <Card.Header className="accordion__item__header">
      <Accordion.Toggle as={Button} className="accordion-button" variant="link" eventKey="3">
        Multi Asset
      </Accordion.Toggle>
    </Card.Header>

    <Accordion.Collapse eventKey="3">

      <Card.Body>


            <NavLink to="/market/EpicipWealthFund" className="navlink a">Epicip Wealth Fund</NavLink><br/>
            <NavLink to="/market/EpicipDiversifiedIncomeFund" className="navlink a">Epicip Diversified Income</NavLink><br/>
            <NavLink to="/market/EpicipMultiAssetFund" className="navlink a">Multi Asset Balanced</NavLink><br/>
            <NavLink to="/market/EpicipMultiAssetGrowthFund" className="navlink a">Epicip Multi Asset Growth</NavLink>



      </Card.Body>

    </Accordion.Collapse>
    </Card>

    <Card className="accordion__card">

      <Card.Header className="accordion__item__header">
        <Accordion.Toggle as={Button} className="accordion-button" variant="link" eventKey="0">
        Discretionary Fund
        </Accordion.Toggle>
      </Card.Header>

      <Accordion.Collapse eventKey="0">

        <Card.Body>

            <NavLink to="/market/EpiciNfaUcitsFundRoute" className="navlink a">Epicip UCITS – NFA Global Bond Fund UI</NavLink><br/>
            <NavLink to="/market/EpicNextGenUcitsFundRoute" className="navlink a">Epicip UCITS – Next Generation Global Bond Fund UI</NavLink><br/>

        </Card.Body>

      </Accordion.Collapse>
    </Card>
    <Card className="accordion__card">

<Card.Header className="accordion__item__header">
  <Accordion.Toggle as={Button} className="accordion-button" variant="link" eventKey="4">
  Insights
  </Accordion.Toggle>
</Card.Header>

<Accordion.Collapse eventKey="4">

  <Card.Body>

      <NavLink to="/market/EpicInsights" className="navlink a">Epic Insights</NavLink><br/>

  </Card.Body>

</Accordion.Collapse>
</Card>

</Accordion> */

<section className="main-box">
  <div className="container">
    <div className="row">
      <div className="col-lg-3 col-md-3 col-sm-4">
        <Sidebar StateSession={{StateSession:StateSession,"url":"EpicfinanceTrends","group":"Managed Futures"}}/>
      </div>
      <div className="col-lg-8 col-md-8 col-sm-8 offset-md-1">
    <ul className="nav nav-tabs custom-nav-tabs" role="tablist">
      <li className="nav-item nav-item-tabs"> <a className="nav-link active" data-toggle="tab" id="summaryButton" href="#nine" role="tab" onClick={summaryButton}>Summary</a> </li>
      <li className="nav-item nav-item-tabs"> <a className="nav-link" data-toggle="tab" href="#eight" onClick={portfolioButton} role="tab">Portfolio</a> </li>
      <li className="nav-item nav-item-tabs"> <a className="nav-link" data-toggle="tab" href="#one" onClick={performanceButton}  role="tab">Performance</a> </li>
      <li className="nav-item nav-item-tabs"> <a className="nav-link " data-toggle="tab" href="#two" role="tab">Commentary</a> </li>
      <li className="nav-item nav-item-tabs"> <a className="nav-link" data-toggle="tab" href="#three" onClick={informationButton} role="tab">Information</a> </li>
      <li className="nav-item nav-item-tabs"> <a className="nav-link" data-toggle="tab" href="#four" id="literatureTab" onClick={literatureButton} role="tab">Literature</a> </li>  
    </ul>
    <div className="tab-content">
      <div className="tab-pane fade active show" id="nine" role="tabpanel">
        <div className="row">
          <div className="col-sm-12">
            <div role="tabpanel" aria-hidden="false" className="fade tab-pane active show">
               
                <div className="row">
                <div className="col">
                      <div className="Paragraph__ParagraphContainer-sc-2ra4j2-0 gnBxSc">
                          <div>
                            { LiteratureSummaryDataState.length>0 ? <div><h3><b>Product Overview</b></h3></div>  : ""}
                            { LiteratureSummaryDataState.length>0 ? LiteratureSummaryDataState.map(renderLiteratureDataPO) :""}
                          </div>
                      </div>
                    </div>
                    
                    <div className="col-md-12">
                    { PressCoverageState.length>0 ? <h3><b>Recent Updates</b></h3>  : ""}
                    </div>
                    { PressCoverageState.length>0 ? PressCoverageState.map(renderLiteratureDataRecent) :""}
                    <div className="col-md-12"></div>
                    {/* <div className="col">
                        <div className="Paragraph__ParagraphContainer-sc-2ra4j2-0 gnBxSc">
                            <div>
                                <h3 className="Paragraph__Heading-sc-2ra4j2-2 dfMrdv">Fund Objectives</h3>
                                <div className="Paragraph__NormalParagraph-sc-2ra4j2-1 dISjjZ">
                                    <p className="Paragraph__Body-sc-2ra4j2-4 gIzxtZ">
                                        The Fund seeks to provide capital appreciation over the medium term with a target annualised volatility of 15%. It aims to perform independently of traditional stock and bond investments, thereby providing valuable diversification benefits and potentially improving the risk/reward profile of a traditional portfolio. 
                                    </p>
                                </div>
                            </div>
                            <span>Key Investor Information can be found 
                                <button className="FundInformation__ButtonLink-sc-1gcw03z-0 iZcztK">here</button>.
                            </span>
                            <div>
                                <h3 className="Paragraph__Heading-sc-2ra4j2-2 dfMrdv">Trading Strategy</h3>
                                <div className="Paragraph__NormalParagraph-sc-2ra4j2-1 dISjjZ">
                                    <p className="Paragraph__Body-sc-2ra4j2-4 gIzxtZ">The investment manager employs a systematic, proprietary, trend following strategy which trades across global UCITS eligible exchange traded financial futures.</p>
                                </div>
                            </div>
                        </div>
                    </div> */}
                
                    {/* <div role="tabpanel" aria-hidden="false" className="fade tab-pane active show"> */}
                        {/* <div classes="mb-1" className="row"> */}
                            <div className="col">
                                <div className="Paragraph__ParagraphContainer-sc-2ra4j2-0 gnBxSc">
                                    <div>                              

                                        {/* <h3 className="Paragraph__Heading-sc-2ra4j2-2 dfMrdv">{HeadingState}</h3> */}
                                        <div className="Paragraph__NormalParagraph-sc-2ra4j2-1 dISjjZ " dangerouslySetInnerHTML={{ __html: ObjectiveState }}>
                                            
                                            {/* <p className="Paragraph__Body-sc-2ra4j2-4 gIzxtZ" dangerouslySetInnerHTML={{ __html: ObjectiveState }}>
                                                
                                            </p> */}
                                        </div>
                                    </div>
                                    <span>
                                        Key Investor Information can be found 
                                        <a href="#" onClick={Clicked}className="InvestorInfo a">&nbsp;here</a>.
                                    </span><br/><br/>
                                    {/* <div>
                                        <h3 className="Paragraph__Heading-sc-2ra4j2-2 dfMrdv">Trading Strategy</h3>
                                        <div className="Paragraph__NormalParagraph-sc-2ra4j2-1 dISjjZ">
                                            <p className="Paragraph__Body-sc-2ra4j2-4 gIzxtZ">
                                                The investment manager employs a systematic, proprietary, trend following strategy which trades across global UCITS eligible exchange traded financial futures.
                                            </p>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        {/* </div> */}
                        <div className="row margin-1 daily-price-row">
                            <div className="col">
                                <div>
                                    <h3 className="Paragraph__Heading-sc-2ra4j2-2">Daily Prices</h3>
                                    <div className="DailyPricing__Boxes-sc-62f3gi-0 biswZj">
                                        {arrPRTUState.map(renderDailyPrices)}

                                       
                                        {/* <div className="DailyPricing__DailyPriceCard-sc-62f3gi-1 coIgZR">
                                            <div className="DailyPricing__DailyPrice-sc-62f3gi-2 gsZde">£{arrPRTUState[1]}</div>
                                            <div className="DailyPricing__DailyPriceName-sc-62f3gi-3 iLShEo">Class A<br/><span className="daily-span">(GBP Hedged) Shares</span></div>
                                        </div>
                                        <div className="DailyPricing__DailyPriceCard-sc-62f3gi-1 coIgZR">
                                            <div className="DailyPricing__DailyPrice-sc-62f3gi-2 gsZde">€{arrPRTUState[2]}</div>
                                            <div className="DailyPricing__DailyPriceName-sc-62f3gi-3 iLShEo">Class A <br/><span className="daily-span">(EUR Hedged) Shares </span></div>
                                        </div>
                                        <div className="DailyPricing__DailyPriceCard-sc-62f3gi-1 coIgZR">
                                            <div className="DailyPricing__DailyPrice-sc-62f3gi-2 gsZde">${arrPRTUState[3]}</div>
                                            <div className="DailyPricing__DailyPriceName-sc-62f3gi-3 iLShEo">Class B<br/><span className="daily-span">(USD) Shares</span></div>
                                        </div>
                                        <div className="DailyPricing__DailyPriceCard-sc-62f3gi-1 coIgZR">
                                            <div className="DailyPricing__DailyPrice-sc-62f3gi-2 gsZde">£{arrPRTUState[4]}</div>
                                            <div className="DailyPricing__DailyPriceName-sc-62f3gi-3 iLShEo">Class B<br/><span className="daily-span">(GBP Hedged) Shares</span></div>
                                        </div>
                                        <div className="DailyPricing__DailyPriceCard-sc-62f3gi-1 coIgZR">
                                            <div className="DailyPricing__DailyPrice-sc-62f3gi-2 gsZde">€{arrPRTUState[5]}</div>
                                            <div className="DailyPricing__DailyPriceName-sc-62f3gi-3 iLShEo">Class B<br/><span className="daily-span">(EUR Hedged) Shares</span></div>
                                        </div>
                                        <div className="DailyPricing__DailyPriceCard-sc-62f3gi-1 coIgZR">
                                            <div className="DailyPricing__DailyPrice-sc-62f3gi-2 gsZde">${arrPRTUState[6]}</div>
                                            <div className="DailyPricing__DailyPriceName-sc-62f3gi-3 iLShEo">Class X<br/><span className="daily-span">(USD) Shares</span></div>
                                        </div> */}
                                    </div>
                                    <div className="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                                        <p className="mt-2">Data as at: {DailyDate}<br/>
                                        <span className="mt-1">Source: EPIC Investment Partners (Ireland) Limited</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row margin-1">
                            <div className="col">
                                <h3 className="Paragraph__Heading-sc-2ra4j2-2">Investment Team</h3>
                                {/* <h3 className="Paragraph__SubHeading-sc-2ra4j2-3 dtCYUm">Darran Goodwin - Fund Manager</h3> */}
                                <p className="Paragraph__Body-sc-2ra4j2-4 gIzxtZ" dangerouslySetInnerHTML={{ __html: TeamState }}>

                                </p>
                            </div>
                            </div>
                            {/* </div> */}
                
                
                
                
                  </div>
                </div>
                {/* <div className="row">
                    <div className="col">
                        <h3 className="Paragraph__Heading-sc-2ra4j2-2 dfMrdv">Investment Team</h3>
                        <h3 className="Paragraph__SubHeading-sc-2ra4j2-3 dtCYUm">Mark Harris - Fund Manager</h3>
                        <p className="Paragraph__Body-sc-2ra4j2-4 gIzxtZ">Mark is the lead Fund Manager of Garraway’s range of multi-asset funds. Mark joined Garraway in 2019 from City Financial where he headed the multi-asset team, joining in October 2012 as part of its acquisition of Eden Asset Management. He joined Eden in 2011 to head its multi-asset business. In 2009, he joined Henderson following its acquisition of New Star Asset Management, leading a team of six managing over £2 billion in assets across a range of low to high-risk mandates. He had previously spent six years at New Star Asset Management managing a range of award-winning funds. Mark has a degree in Law and Economics from Newcastle University.</p>
                        <h3 className="Paragraph__SubHeading-sc-2ra4j2-3 dtCYUm">Pushpanshu Prakash - Senior Investment Analyst</h3>
                        <p className="Paragraph__Body-sc-2ra4j2-4 gIzxtZ">Pushpanshu joined Garraway in 2019 from City Financial where he was a fund analyst for the Multi Asset team responsible for fund specific research and quantitative modelling. He joined City Financial in 2017 after graduating from University College London (UCL) with an MSci in Mathematics, where he completed his thesis in fluid dynamics with a focus on situational modelling and financial mathematics. Prior to starting his career in financial services, he completed internships at the UCL School of Management, Atlantic Trading and Procter &amp; Gamble.</p>
                    </div>
                </div> */}

          </div>
          
        </div>
      </div>
      <div className="tab-pane fade" id="eight" role="tabpanel">
        <div className="row chart-row">
          <div className="col-md-6 chart-block-finance"> 
            <p className="lse_redirect">Net Notional Sector Exposures (% NAV)</p>
            <p className="lse_redirect"><a className="display-none" target="_blank" href="transaction-own-share.php">Transaction In Own Share</a></p>
            {portfolioStatus === false ? "" : 
            <ResponsiveContainer width="100%" height="90%">
            <BarChart
              width={500}
              height={1000}
              data={graphData}
              // data
              layout="vertical"
              margin={{
                top: 5,
                right: 30,
                left: 30,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="" horizontal="" vertical="true" />
              <XAxis  type="number" orientation="top" axisLine={false} tickFormatter={(tick) => {
               return `${tick}%`;
               }} />
              <YAxis type="category" interval={0} dataKey="name"  />
              <Tooltip />
              {/* <Legend className="legend-net" /> */}
              <ReferenceLine y={0} stroke="#000" />
              <Bar dataKey="current month" fill="#1a2352" />
              <Bar dataKey="pevious month" fill="#9DB1DB" />
            </BarChart>
            </ResponsiveContainer>
            }
            
          </div>

          <div className="col-md-6 VARmargin chart-block-finance"> 
            <p className="lse_redirect">Portfolio VaR by Sector (% NAV)</p>
            <p className="lse_redirect"><a className="display-none" target="_blank" href="transaction-own-share.php">Transaction In Own Share</a></p>
            
            <ResponsiveContainer width="100%" height="80%">
            <BarChart
              width={500}
              height={300}
              data={graphDataVAR}
              // VARdata
              
              layout="vertical"
              margin={{
                top: -10,
                right: 30,
                left: 15,
                bottom: -10,
              }}
            >
                <CartesianGrid strokeDasharray="" horizontal="" vertical="true" />
                <XAxis type="number" orientation="top" axisLine={false}      tickFormatter={(tick) => {
                   return `${tick}%`;
                   }}
               />
                <YAxis type="category"  dataKey="name"  />
                <Tooltip />
                {/* <Legend /> */}
                <ReferenceLine y={0} stroke="#000" />
                {/* <Bar dataKey="pv" fill="#8884d8" /> */}
                <Bar dataKey="value" fill="#9DB1DB" >
                {
                          graphDataVAR.map((entry, index) => (
                            <Cell key={`cell-${index}`}  stroke={colors[index]}  strokeWidth={index === 2 ? 4 : 1} fill={colors[index % 20]}/>
                          ))
                        }
                        </Bar>
            </BarChart>
            </ResponsiveContainer>
         
          </div>
          
        </div>
        <div className="row chart-row">
          <div className="col-md-6"> 

            <div>Exposures do not include share class hedges, only notional exposure from futures
positions within the portfolio. Where FX Sector exposures are shown, both sides of
the contract contribute to the relevant currency exposure.
            </div>
          
          </div>
          <div className="col-md-6 chart-block"> 
            <p className="lse_redirect">Performance by Sector</p>
            <p className="lse_redirect"><a className="display-none" target="_blank" href="transaction-own-share.php">Transaction In Own Share</a></p>
            
             <ResponsiveContainer width="100%" height="75%">
                <BarChart
                  width={500}
                  height={300}
                  data={graphDataSectorPer}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                    <CartesianGrid strokeDasharray="" horizontal="true" vertical="" />
                    <XAxis dataKey="name" tick={CustomizedAxisTick} type="category" interval={0} axisLine={false} />
                    <YAxis  tickFormatter={(tick) => {
                         return `${tick}%`;
                         }}
                    />
                    {/* <Legend /> */}
                    <Tooltip/>
                    <ReferenceLine y={0} stroke="#000" />
                    {/* <Bar dataKey="pv" fill="#8884d8" /> */}
                    <Bar dataKey="value" fill="#82ca9d" >
                    
                        {
                          graphDataSectorPer.map((entry, index) => (
                            <Cell key={`cell-${index}`}  stroke={colors[index]}  strokeWidth={index === 2 ? 4 : 1} fill={colors[index % 20]}/>
                          ))
                        }                        
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
                    <Tooltip />
                    
          
          </div>
          
        </div>
        <div className="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                     <p className="mt-2 i">Monthly data as at: {PRTUDate}. 
                     All information also available to download <a href={config.apiPath + "/sitepdfs/epic_financial_trends.pdf"} target="_blank">here</a>
                      <br/></p>
                  </div>
      </div>
      <div className="tab-pane fade" id="one" role="tabpanel">
        <div className="row table-row">
          <div className="col-sm-12">
            <div role="tabpanel" aria-hidden="false" className="fade tab-pane active show">
            <div className="row">
                    <div className="col table-responsive" >
                    <table className="table  CumulativePerformance__Table-sc-51pab9-0 hRUkzz_new hRUkzz_new_one">
                            <tbody>
                                <tr className="CumulativePerformance__TopRow-sc-51pab9-1 dwdfBh">
                                
                                  {cummulatovePerfData.map(renderCummulativePerformanceNames)}
                                  


                                </tr>
                                <tr className="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">
                                    
                                  {cummulatovePerfData.map(renderCummulativePerformanceValue)}

                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row">
                    <div className="col  table-responsive" >
                        <table className="table  CumulativePerformance__Table-sc-51pab9-0 hRUkzz">
                            <tbody>
                                <tr className="CumulativePerformance__TopRow-sc-51pab9-1 dwdfBh">
                                
                                {twelvemonPerfDiscreteAPI.map(rendertwelvemonPerfDiscreteAPINames)}
                                    {/* <th>Cumulative Performance</th>
                                    <th>1m</th>
                                    <th>1Yr</th>
                                    <th>3Yr</th>
                                    <th>5Yr</th>
                                    <th>Since UCITS Strategy Relaunch</th>
                                    <th>Since Inception</th> */}
                                </tr>
                                <tr className="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">
                                
                                {twelvemonPerfDiscreteAPI.map(rendertwelvemonPerfDiscreteAPIValue)}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                
                <div className="row remove_margin_multi_asset remove_margin_multi_asset_once">
                    <div className="pr-md-1 col-12 col-md-6 col table-div-margin remove_margin  table-responsive" >
                        <table className="table  AssetClass__Table-sc-1rmhbx4-3 iiGyjEGR iiGyjEGR_dfm iiGyjEGR_dfm_onece">
                            <tbody className="AssetClass__Body-sc-1rmhbx4-4 cyhKrw">
                                <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ">
                                    <th colSpan="1" className="align-left">Top Three Contributors</th>
                                    <th colSpan="1" className="align-right">Gross Attribution</th>
                                </tr>

                                {top3contriarray.map(rendertop3contri)}

                            </tbody>
                        </table>
                    </div>
                    <div className="pr-md-1 col-12 col-md-6 col table-div-margin remove_margin  table-responsive">

                      <table className="table  AssetClass__Table-sc-1rmhbx4-3 iiGyjE iiGyjE_dfm iiGyjE_dfmnewonce">
                          <tbody className="AssetClass__Body-sc-1rmhbx4-4 cyhKrw">
                              <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ">
                                    <th style={{width: "60%"}} className="align-left">Bottom Three Contributors</th>
                                    <th style={{width: "30%"}} className="align-right">Gross Attribution</th>
                                </tr>
                                {bot3contriarray.map(renderbot3contri)}
                                

                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="mb-2 row">
                    <div className="col" >
                    <div className="MonthlyPerformance__Wrapper-sc-1n33bhd-0 cHAvbZ  table-responsive">
                        <table className=" MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW">
                                <tbody className="table MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    <tr>
                                        <th colSpan="99" className="MonthlyPerformance__Title-sc-1n33bhd-1 ekfIgT">
                                            Monthly Performance – GFT Class B GBP</th>
                                    </tr>
                                    <tr color="#d8e2e8" className="MonthlyPerformance__Row-sc-1n33bhd-4 elqUjA">

                                        {monthsArrayState.map(renderMonthNames)}

                                    </tr>
                                    
                                    <tr className="MonthlyPerformance__Row-sc-1n33bhd-4 oKXFa">
                                    
                                    </tr>
                                  
                                </tbody>
                            </table>

                            <table className="table MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW table-striped">
                                <tbody className="MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    {monthlyPerformance2DArrayState.map(render12MonthsData)}
                                </tbody>
                            </table>


                            <table className=" MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW">
                                <tbody className="table MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    <tr>
                                        <th colSpan="99" className="MonthlyPerformance__Title-sc-1n33bhd-1 ekfIgT">
                                         Monthly Performance – GFT Class A USD</th>
                                    </tr>
                                    <tr color="#d8e2e8" className="MonthlyPerformance__Row-sc-1n33bhd-4 elqUjA">

                                        {monthsArrayStateUSD.map(renderMonthNames)}

                                        </tr>
                                </tbody>
                            </table>

                            <table className="table MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW table-striped">
                                <tbody className="MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    {monthlyPerformance2DArrayStateUSD.map(render12MonthsData)}
                                </tbody>
                            </table>


                            <table className=" MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW">
                                <tbody className="table MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    <tr>
                                        <th colSpan="99" className="MonthlyPerformance__Title-sc-1n33bhd-1 ekfIgT">
                                        Monthly Performance – GFT Class A EUR</th>
                                    </tr>
                                    <tr color="#d8e2e8" className="MonthlyPerformance__Row-sc-1n33bhd-4 elqUjA">

                                        {monthsArrayStateAEUR.map(renderMonthNames)}

                                        </tr>
                                </tbody>
                            </table>

                            <table className="table MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW table-striped">
                                <tbody className="MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    {monthlyPerformance2DArrayStateAEUR.map(render12MonthsData)}
                                </tbody>
                            </table>


                            <table className=" MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW">
                                <tbody className="table MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    <tr>
                                        <th colSpan="99" className="MonthlyPerformance__Title-sc-1n33bhd-1 ekfIgT">
                                        Monthly Performance – GFT Class B USD</th>
                                    </tr>
                                    <tr color="#d8e2e8" className="MonthlyPerformance__Row-sc-1n33bhd-4 elqUjA">

                                        {monthsArrayStateUSDB.map(renderMonthNames)}

                                        </tr>
                                </tbody>
                            </table>

                            <table className="table MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW table-striped">
                                <tbody className="MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    {monthlyPerformance2DArrayStateUSDB.map(render12MonthsData)}
                                </tbody>
                            </table>



                            <table className=" MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW">
                                <tbody className="table MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    <tr>
                                        <th colSpan="99" className="MonthlyPerformance__Title-sc-1n33bhd-1 ekfIgT">
                                        Monthly Performance – GFT Class B EUR</th>
                                    </tr>
                                    <tr color="#d8e2e8" className="MonthlyPerformance__Row-sc-1n33bhd-4 elqUjA">

                                        {monthsArrayStateBEUR.map(renderMonthNames)}

                                        </tr>
                                </tbody>
                            </table>

                            <table className="table MonthlyPerformance__Table-sc-1n33bhd-2 bDbyAW table-striped">
                                <tbody className="MonthlyPerformance__Body-sc-1n33bhd-3 eLhmcV">
                                    {monthlyPerformance2DArrayStateBEUR.map(render12MonthsData)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                     <p className="mt-2 i">Monthly data as at: {PRTUDate}.
                      All information also available to download <a download href={config.apiPath + "/sitepdfs/epic_financial_trends.pdf"} target="_blank" >here </a> 
                      <br/></p>
                  </div>
            </div>
          </div>

        </div>
      </div>
      <div className="tab-pane fade" id="two" role="tabpanel">
        <div className="row">
          <div className="col-sm-12">
          <div role="tabpanel" aria-hidden="false" className="fade tab-pane active show">
              <div className="mb-2 row">
                  <div className="col-md-12"  dangerouslySetInnerHTML={{ __html: productsCommentary }}>
                  </div>
                </div>
                <div className="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                     <p className="mt-2 i">Monthly data as at: {PRTUDate}.
                      All information also available to download <a href={config.apiPath + "/sitepdfs/epic_financial_trends.pdf"} target="_blank" download>here </a> 
                      <br/></p>
                  </div>
                    </div>            
          </div>
          
        </div>
      </div>
      <div className="tab-pane fade" id="three" role="tabpanel">
        <div className="row">
          <div className="col-sm-12">
            <div role="tabpanel" aria-hidden="false" className="fade tab-pane active show">
                <div className="mb-3 row">
                    <div className="col  table-responsive" >
                        <table className="FundInformation__Table-sc-18irt95-0 cRUpgb">
                            <tbody className=" FundInformation__Body-sc-18irt95-1 hNmQXY">
                                <tr className="FundInformation__Row-sc-18irt95-2 kzFInj">
                                    <th>Fund Information</th>
                                </tr>
                                {Fundinfoarray.map(renderFundinfo)}
                                {CMSFundinfoarray.map(renderFundinfo)}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row">
                    <div className="col  table-responsive" >
                        <table className="table  Shares__Table-sc-1brks4f-0 hBbtmd">
                            <tbody className="Shares__Body-sc-1brks4f-1 hbWYKC">
                                <tr className="Shares__Row-sc-1brks4f-2 hzpAKA">
                                  {ShareClassarray.map(renderShareClassNames)}
                                </tr>
                                <tr className="Shares__Row-sc-1brks4f-2 eoQrEv">
                                  {ShareClassarray.map(renderShareClassValue)}
                                </tr>
                                {CMSshareinfoarray.map(renderCMSshareinfo)}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                     <p className="mt-2 i">Monthly data as at: {PRTUDate}.
                      All information also available to download <a href={config.apiPath + "/sitepdfs/epic_financial_trends.pdf"} target="_blank" download>here </a> 
                      <br/></p>
                  </div>

            </div>
            
          </div>
          
        </div>
      </div>
      <div className="tab-pane fade" id="four" role="tabpanel">
        <div className="row">
          <div className="col-sm-12">
          <div className="row">
               

         
          { KeyInveInfoState.length>0 ? <div className="col-md-12"><h3><b>Key Investor Information</b></h3><br/></div>  : ""}
          { KeyInveInfoState.length>0 ? KeyInveInfoState.map(renderLiteratureData) :""}

          <div className="col-md-12">
					      <h4>Fact Sheet</h4>
                <div className="row">
              <div className="col-md-6">
                <p className="pdf_download">
                  <a href={config.apiPath + "/sitepdfs/epic_financial_trends.pdf"} target="_blank" download>Financial Trends PDF
                        <br/>
                  </a>
                </p>
              </div>
              <div className="col-md-6">
              
                <p className="pdf_download">
                  <a href={config.apiPath + "/sitepdfs/epic_financial_trends_x_usd.pdf"} target="_blank" download>Financial Trends X USD PDF
                        <br/>
                  </a>
                </p>
				      </div>
              </div>
              </div>
          

          { LiteratureDataState.length>0 ? <div className="col-md-12"><h3><b>Other Information</b></h3><br/></div>  : ""}
          { LiteratureDataState.length>0 ? LiteratureDataState.map(renderLiteratureData) :""}
          
          { PressCoverageState.length>0 ? <div className="col-md-12"><h3><b>Recent Updates
            </b></h3><br/></div>  : ""}
          { PressCoverageState.length>0 ? PressCoverageState.map(renderLiteratureData) :""}


          { ApplicationsState.length>0 ? <div className="col-md-12"><h3><b>Applications</b></h3><br/></div>  : ""}
          { ApplicationsState.length>0 ? ApplicationsState.map(renderLiteratureData) :""}

          { ReportsState.length>0 ? <div className="col-md-12"><h3><b>Reports</b></h3><br/></div>  : ""}
          { ReportsState.length>0 ? ReportsState.map(renderLiteratureData) :""}

          { offerDocumentState.length>0 ? <div className="col-md-12"><h3><b>Offering Documents</b></h3><br/></div>  : ""}
          { offerDocumentState.length>0 ? offerDocumentState.map(renderLiteratureData) :""}
             
    


          </div>
            
          </div>
          
        </div>
      </div>
      
    </div>
  </div>
    </div>
  </div>
</section>
:<div className="center"><ReactBootstrap.Spinner animation="border"/></div> 
}
</Fragment>
    );
}
 
export default EpicfinanceTrends;

